import { HttpParams, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Administration } from './administration';

@Injectable({
  providedIn: 'root'
})
export class AdministrationService {
  url = 'https://staff.vie-ecoles.com/server/administration/';
  options = { params: new HttpParams({ fromString: 'token=' + JSON.parse(localStorage.getItem('user')).token }) };

  constructor(private http: HttpClient) { }

  add(table: string, body: Administration): Observable<string> {
    return this.http.post<string>(this.url + table, body, this.options)
      .pipe(catchError(this.handleError));
  }

  put(table: string, body: Administration): Observable<string> {
    return this.http.put<string>(this.url + table, body, this.options)
      .pipe(catchError(this.handleError));
  }

  delete(table: string, id: string, ecole: string = null): Observable<string> {
    if (ecole) {
      return this.http.delete<string>(this.url + table + '/' + ecole + '/' + id, this.options)
        .pipe(catchError(this.handleError));
    } else {
      return this.http.delete<string>(this.url + table + '/' + id, this.options)
        .pipe(catchError(this.handleError));
    }
  }

  list(table: string): Observable<Administration[]> {
    return this.http.get<Administration[]>(this.url + table, this.options)
      .pipe(catchError(this.handleError));
  }

  view(table: string, id: string): Observable<Administration> {
    return this.http.get<Administration>(this.url + table + '/' + id, this.options)
      .pipe(catchError(this.handleError));
  }

  views(table: string, id: string): Observable<Administration[]> {
    return this.http.get<Administration[]>(this.url + table + '/' + id, this.options)
      .pipe(catchError(this.handleError));
  }
  deuxArg(table: string, id: string, id2: string): Observable<Administration> {
    return this.http.get<Administration>(this.url + table + '/' + id + '/' + id2, this.options)
      .pipe(catchError(this.handleError));
  }

  deuxArgs(table: string, id: string, id2: string): Observable<Administration[]> {
    return this.http.get<Administration[]>(this.url + table + '/' + id + '/' + id2, this.options)
      .pipe(catchError(this.handleError));
  }

  troisArg(table: string, id: string, id2: string, id3: string): Observable<Administration> {
    return this.http.get<Administration>(this.url + table + '/' + id + '/' + id2 + '/' + id3, this.options)
      .pipe(catchError(this.handleError));
  }

  troisArgs(table: string, id: string, id2: string, id3: string): Observable<Administration[]> {
    return this.http.get<Administration[]>(this.url + table + '/' + id + '/' + id2 + '/' + id3, this.options)
      .pipe(catchError(this.handleError));
  }

  upload(table: string, formData): Observable<any> {
    return this.http.post<any>(this.url + table, formData, this.options)
      .pipe(catchError(this.handleError));
  }




  private handleError(error: HttpErrorResponse): Observable<never> {
    let response = '';
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      response = `Une erreur s'est produite: ${error.error.message}`;
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(`Backend returned code ${error.status}, body was: `, error.error.message);
      response = `${error.error.message}`;
    }
    // Return an observable with a user-facing error message.
    return throwError(response);
  }
}
